import { useCallback, useMemo, useState } from 'react';

const useProductSelectionsRefresh = ({ refreshProgramName, forceProgramSyncMutation, setSnackbar }) => {
  const [refreshSelectionsPending, setRefreshSelectionsPending] = useState(false);

  const refreshSelectionsLabel = useMemo(
    () => (refreshProgramName ? `Refresh ${refreshProgramName}` : 'Refresh selections'),
    [refreshProgramName]
  );
  const refreshSelectionsDisabled = !refreshProgramName || refreshSelectionsPending;

  const handleRefreshSelections = useCallback(async () => {
    if (!refreshProgramName || refreshSelectionsPending) return;
    setRefreshSelectionsPending(true);
    try {
      const result = await forceProgramSyncMutation.mutateAsync({ programName: refreshProgramName });
      if (result?.queued) {
        setSnackbar({
          open: true,
          message: result?.message || `Queued refresh for ${refreshProgramName}.`,
          severity: 'info',
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: error?.response?.data?.message || error?.message || `Failed to refresh ${refreshProgramName}.`,
        severity: 'error',
      });
    } finally {
      setRefreshSelectionsPending(false);
    }
  }, [forceProgramSyncMutation, refreshProgramName, refreshSelectionsPending, setSnackbar]);

  return {
    refreshSelectionsLabel,
    refreshSelectionsDisabled,
    refreshSelectionsPending,
    handleRefreshSelections,
  };
};

export default useProductSelectionsRefresh;
